var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rg-history-setting-button-wrapper"},[_c('rg-history-setting-button',{class:_vm.buttonAdditionalClass,style:(_vm.buttonStyle),attrs:{"tooltipSettings":{
      text: '過去履歴表示',
      position: 'right',
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }